import { render, staticRenderFns } from "./WarningMessage.vue?vue&type=template&id=e325ac42"
import script from "./WarningMessage.vue?vue&type=script&lang=ts"
export * from "./WarningMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports